export const colorId = {
  225285: 'no-color', // ohne Farb-Bezeichnung
  219053: 'no-color', // ohne Farb-Bezeichnung
  145415: 'multi-color', // multicolor
  orange: '#FF4500', // orange
  277174: '#FF4500', // orange
  268859: '#FF4500', // orange
  pink: '#FF69B4', // pink
  277181: '#FF69B4', // pink
  270456: '#FF69B4', // pink
  145413: '#808080', // grau
  145420: '#FFC0CB', // rosa
  145419: '#800080', // lila
  145417: '#FFFFFF', // weiss
  147456: '#FFFFFF', // weiß // for whatever reason there are two 'whites': 'weiss' and 'weiß'
  145409: '#FF0000', // rot
  145410: '#00FFFF', // aqua
  145414: '#FFFF00', // gelb
  145418: '#008000', // grün
  145412: '#0000FF', // blau
  145408: '#000000', // schwarz
  145411: '#793D00', // braun
  860735: '#E2D2C2', // beige
} as Record<string | number, string>
